<template>
  <div>
    <el-dialog
      title="发送喇叭消息"
      center
      width="700px"
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form>
        <el-form-item label="输入要发送的文本：">
          <el-input v-model="toBeSentText"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" icon="el-icon-s-promotion" @click="submit()"
          >立即发送</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true,
      toBeSentText: "", // 要发送的文本
    };
  },

  methods: {
    /**
     * 提交表单
     */
    async submit() {
        this.$message({
            type: "success",
            message: "发送成功"
        })

      this.close();
    },

    /**
     * 关闭自己
     */
    close() {
      this.visible = false;
    },

    /**
     * 自己被关闭了
     */
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>
